export default __webpack_public_path__ + "locales/pl/JavascriptSdk.json?hash=7974c995f62f2134d9ea1eb04a56b260";